import React from 'react';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import Form from '$/components/ui/Form';
import Input from '$/components/ui/Input/Basics/Input';
import ToggleOnOff from '$/components/ui/Input/Basics/ToggleOnOff';

const ContactRequestModalSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = () => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <>
            <Form.FieldLabel title='Send contact request to this email' />
            <Form.Field
              name='details.email'
              className='mb-0'
              component={<Input placeholder={'Email'} />}
            />
            <Form.Field
              className='mt-1/2e mb-1e'
              name='details.requireEmail'
              component={<ToggleOnOff label={'Require email field'} />}
            />
            <Form.StopNonHubspotForm />
          </>
        ),
      },
    },
  ];
};

export default ContactRequestModalSettings;
